/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  OrderReportBase,
  OrderReportBaseOptional,
  OrderReportBaseMetaI,
  OrderReportBaseTrackedI,
} from "./order-report-base";
import {
  OrderReportBaseTracked,
  OrderReportBaseMeta,
} from "./order-report-base";
// May contain unused imports in some cases
// @ts-ignore
import type {
  OrderReportDTO,
  OrderReportDTOOptional,
  OrderReportDTOMetaI,
  OrderReportDTOTrackedI,
} from "./order-report-dto";
import { OrderReportDTOTracked, OrderReportDTOMeta } from "./order-report-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  ReportDTO,
  ReportDTOOptional,
  ReportDTOMetaI,
  ReportDTOTrackedI,
} from "./report-dto";
import { ReportDTOTracked, ReportDTOMeta } from "./report-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  ReportMetaDTO,
  ReportMetaDTOOptional,
  ReportMetaDTOMetaI,
  ReportMetaDTOTrackedI,
} from "./report-meta-dto";
import { ReportMetaDTOTracked, ReportMetaDTOMeta } from "./report-meta-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  ReportStatus,
  ReportStatusOptional,
  ReportStatusMetaI,
  ReportStatusTrackedI,
} from "./report-status";
import { ReportStatusTracked, ReportStatusMeta } from "./report-status";
// May contain unused imports in some cases
// @ts-ignore
import type {
  ReportType,
  ReportTypeOptional,
  ReportTypeMetaI,
  ReportTypeTrackedI,
} from "./report-type";
import { ReportTypeTracked, ReportTypeMeta } from "./report-type";
// May contain unused imports in some cases
// @ts-ignore
import type {
  ReportTypeCountDTO,
  ReportTypeCountDTOOptional,
  ReportTypeCountDTOMetaI,
  ReportTypeCountDTOTrackedI,
} from "./report-type-count-dto";
import {
  ReportTypeCountDTOTracked,
  ReportTypeCountDTOMeta,
} from "./report-type-count-dto";

/**
 *
 * @export
 * @interface OrderReportsDTO
 */
export interface OrderReportsDTOOptional extends OrderReportBaseOptional {
  /**
   *
   * @type {boolean}
   * @memberof OrderReportsDTO
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof OrderReportsDTO
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof OrderReportsDTO
   */
  reportId?: number;
  /**
   *
   * @type {string}
   * @memberof OrderReportsDTO
   */
  reportKey?: string;
  /**
   *
   * @type {string}
   * @memberof OrderReportsDTO
   */
  reportTitle?: string;
  /**
   *
   * @type {ReportType}
   * @memberof OrderReportsDTO
   */
  reportType?: ReportType;
  /**
   *
   * @type {ReportStatus}
   * @memberof OrderReportsDTO
   */
  reportStatus?: ReportStatus;
  /**
   *
   * @type {Array<ReportDTO>}
   * @memberof OrderReportsDTO
   */
  childReports?: ReportDTOOptional[];
  /**
   *
   * @type {Array<ReportMetaDTO>}
   * @memberof OrderReportsDTO
   */
  meta?: ReportMetaDTOOptional[];
  /**
   *
   * @type {Array<ReportTypeCountDTO>}
   * @memberof OrderReportsDTO
   */
  typeCounts?: ReportTypeCountDTOOptional[];
  /**
   *
   * @type {number}
   * @memberof OrderReportsDTO
   */
  totalAmountPaidLineItems?: number;
  /**
   *
   * @type {number}
   * @memberof OrderReportsDTO
   */
  totalAmountBaseLineItems?: number;
  /**
   *
   * @type {number}
   * @memberof OrderReportsDTO
   */
  totalAmountSubtotalLineItems?: number;
  /**
   *
   * @type {number}
   * @memberof OrderReportsDTO
   */
  totalAmountTaxesLineItems?: number;
  /**
   *
   * @type {number}
   * @memberof OrderReportsDTO
   */
  totalAmountTotalLineItems?: number;
  /**
   *
   * @type {number}
   * @memberof OrderReportsDTO
   */
  totalAmountDiscountLineItems?: number;
  /**
   *
   * @type {number}
   * @memberof OrderReportsDTO
   */
  totalAmountPaymentsPaid?: number;
  /**
   *
   * @type {number}
   * @memberof OrderReportsDTO
   */
  totalAmountStripePaymentsPaid?: number;
  /**
   *
   * @type {Array<OrderReportDTO>}
   * @memberof OrderReportsDTO
   */
  orderReports?: OrderReportDTOOptional[];
  /**
   *
   * @type {number}
   * @memberof OrderReportsDTO
   */
  totalTotalAmountFromOrders?: number;
  /**
   *
   * @type {number}
   * @memberof OrderReportsDTO
   */
  totalBaseAmountFromOrders?: number;
  /**
   *
   * @type {number}
   * @memberof OrderReportsDTO
   */
  totalPaidAmountFromOrders?: number;
}

export interface OrderReportsDTO
  extends OrderReportsDTOOptional, OrderReportBase, ReportDTO {
  /**
   *
   * @type {boolean}
   * @memberof OrderReportsDTO
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof OrderReportsDTO
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof OrderReportsDTO
   */
  reportId: number;
  /**
   *
   * @type {string}
   * @memberof OrderReportsDTO
   */
  reportKey: string;
  /**
   *
   * @type {string}
   * @memberof OrderReportsDTO
   */
  reportTitle?: string;
  /**
   *
   * @type {ReportType}
   * @memberof OrderReportsDTO
   */
  reportType?: ReportType;
  /**
   *
   * @type {ReportStatus}
   * @memberof OrderReportsDTO
   */
  reportStatus?: ReportStatus;
  /**
   *
   * @type {Array<ReportDTO>}
   * @memberof OrderReportsDTO
   */
  childReports?: ReportDTO[];
  /**
   *
   * @type {Array<ReportMetaDTO>}
   * @memberof OrderReportsDTO
   */
  meta?: ReportMetaDTO[];
  /**
   *
   * @type {Array<ReportTypeCountDTO>}
   * @memberof OrderReportsDTO
   */
  typeCounts?: ReportTypeCountDTO[];
  /**
   *
   * @type {number}
   * @memberof OrderReportsDTO
   */
  totalAmountPaidLineItems?: number;
  /**
   *
   * @type {number}
   * @memberof OrderReportsDTO
   */
  totalAmountBaseLineItems?: number;
  /**
   *
   * @type {number}
   * @memberof OrderReportsDTO
   */
  totalAmountSubtotalLineItems?: number;
  /**
   *
   * @type {number}
   * @memberof OrderReportsDTO
   */
  totalAmountTaxesLineItems?: number;
  /**
   *
   * @type {number}
   * @memberof OrderReportsDTO
   */
  totalAmountTotalLineItems?: number;
  /**
   *
   * @type {number}
   * @memberof OrderReportsDTO
   */
  totalAmountDiscountLineItems?: number;
  /**
   *
   * @type {number}
   * @memberof OrderReportsDTO
   */
  totalAmountPaymentsPaid?: number;
  /**
   *
   * @type {number}
   * @memberof OrderReportsDTO
   */
  totalAmountStripePaymentsPaid?: number;
  /**
   *
   * @type {Array<OrderReportDTO>}
   * @memberof OrderReportsDTO
   */
  orderReports: OrderReportDTO[];
  /**
   *
   * @type {number}
   * @memberof OrderReportsDTO
   */
  totalTotalAmountFromOrders?: number;
  /**
   *
   * @type {number}
   * @memberof OrderReportsDTO
   */
  totalBaseAmountFromOrders?: number;
  /**
   *
   * @type {number}
   * @memberof OrderReportsDTO
   */
  totalPaidAmountFromOrders?: number;
}

export interface OrderReportsDTOTrackedI extends OrderReportBaseOptional {
  /**
   *
   * @type {boolean}
   * @memberof OrderReportsDTO
   */
  isDeleted?: boolean;
  isDeletedIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof OrderReportsDTO
   */
  isNew?: boolean;
  isNewIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof OrderReportsDTO
   */
  reportId?: number;
  reportIdIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof OrderReportsDTO
   */
  reportKey?: string;
  reportKeyIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof OrderReportsDTO
   */
  reportTitle?: string;
  reportTitleIsSet: boolean;
  /**
   *
   * @type {ReportType}
   * @memberof OrderReportsDTO
   */
  reportType?: ReportType;
  reportTypeIsSet: boolean;
  /**
   *
   * @type {ReportStatus}
   * @memberof OrderReportsDTO
   */
  reportStatus?: ReportStatus;
  reportStatusIsSet: boolean;
  /**
   *
   * @type {Array<ReportDTO>}
   * @memberof OrderReportsDTO
   */
  childReports?: ReportDTOTrackedI[];
  childReportsIsSet: boolean;
  /**
   *
   * @type {Array<ReportMetaDTO>}
   * @memberof OrderReportsDTO
   */
  meta?: ReportMetaDTOTrackedI[];
  metaIsSet: boolean;
  /**
   *
   * @type {Array<ReportTypeCountDTO>}
   * @memberof OrderReportsDTO
   */
  typeCounts?: ReportTypeCountDTOTrackedI[];
  typeCountsIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof OrderReportsDTO
   */
  totalAmountPaidLineItems?: number;
  totalAmountPaidLineItemsIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof OrderReportsDTO
   */
  totalAmountBaseLineItems?: number;
  totalAmountBaseLineItemsIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof OrderReportsDTO
   */
  totalAmountSubtotalLineItems?: number;
  totalAmountSubtotalLineItemsIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof OrderReportsDTO
   */
  totalAmountTaxesLineItems?: number;
  totalAmountTaxesLineItemsIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof OrderReportsDTO
   */
  totalAmountTotalLineItems?: number;
  totalAmountTotalLineItemsIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof OrderReportsDTO
   */
  totalAmountDiscountLineItems?: number;
  totalAmountDiscountLineItemsIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof OrderReportsDTO
   */
  totalAmountPaymentsPaid?: number;
  totalAmountPaymentsPaidIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof OrderReportsDTO
   */
  totalAmountStripePaymentsPaid?: number;
  totalAmountStripePaymentsPaidIsSet: boolean;
  /**
   *
   * @type {Array<OrderReportDTO>}
   * @memberof OrderReportsDTO
   */
  orderReports?: OrderReportDTOTrackedI[];
  orderReportsIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof OrderReportsDTO
   */
  totalTotalAmountFromOrders?: number;
  totalTotalAmountFromOrdersIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof OrderReportsDTO
   */
  totalBaseAmountFromOrders?: number;
  totalBaseAmountFromOrdersIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof OrderReportsDTO
   */
  totalPaidAmountFromOrders?: number;
  totalPaidAmountFromOrdersIsSet: boolean;
}

transformDatesMap.set("OrderReportsDTO", function (model: OrderReportsDTO) {
  const transformDateschildReports = transformDatesMap.get("ReportDTO");
  if (transformDateschildReports) {
    model.childReports?.forEach((sub) => {
      transformDateschildReports(sub);
    });
  }
  const transformDatesmeta = transformDatesMap.get("ReportMetaDTO");
  if (transformDatesmeta) {
    model.meta?.forEach((sub) => {
      transformDatesmeta(sub);
    });
  }
  const transformDatestypeCounts = transformDatesMap.get("ReportTypeCountDTO");
  if (transformDatestypeCounts) {
    model.typeCounts?.forEach((sub) => {
      transformDatestypeCounts(sub);
    });
  }
  const transformDatesorderReports = transformDatesMap.get("OrderReportDTO");
  if (transformDatesorderReports) {
    model.orderReports?.forEach((sub) => {
      transformDatesorderReports(sub);
    });
  }
});

export type OrderReportsDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  isDeleted: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  isNew: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  reportId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  reportKey: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  reportTitle: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  reportType: PropertyMeta<ReportTypeMetaI>;
  //isDate: false
  //isDatetime: false
  reportStatus: PropertyMeta<ReportStatusMetaI>;
  //isDate: false
  //isDatetime: false
  childReports: PropertyMeta<ReportDTOMetaI>;
  //isDate: false
  //isDatetime: false
  meta: PropertyMeta<ReportMetaDTOMetaI>;
  //isDate: false
  //isDatetime: false
  typeCounts: PropertyMeta<ReportTypeCountDTOMetaI>;
  //isDate: false
  //isDatetime: false
  totalAmountPaidLineItems: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  totalAmountBaseLineItems: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  totalAmountSubtotalLineItems: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  totalAmountTaxesLineItems: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  totalAmountTotalLineItems: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  totalAmountDiscountLineItems: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  totalAmountPaymentsPaid: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  totalAmountStripePaymentsPaid: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  orderReports: PropertyMeta<OrderReportDTOMetaI>;
  //isDate: false
  //isDatetime: false
  totalTotalAmountFromOrders: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  totalBaseAmountFromOrders: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  totalPaidAmountFromOrders: PropertyMeta<MetaTypeBase<number>>;
}>;

export var OrderReportsDTOMeta: OrderReportsDTOMetaI =
  {} as OrderReportsDTOMetaI;
OrderReportsDTOMeta = typeMeta("OrderReportsDTO", {
  isDeleted: propertyMeta(
    "isDeleted",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  isNew: propertyMeta("isNew", false, false, false, MetaTypesBase.boolean),
  reportId: propertyMeta("reportId", false, true, true, MetaTypesBase.number),
  reportKey: propertyMeta(
    "reportKey",
    false,
    true,
    false,
    MetaTypesBase.string,
  ),
  reportTitle: propertyMeta(
    "reportTitle",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  reportType: propertyMeta("reportType", false, false, false, ReportTypeMeta),
  reportStatus: propertyMeta(
    "reportStatus",
    false,
    false,
    false,
    ReportStatusMeta,
  ),
  childReports: propertyMeta("childReports", true, false, false, ReportDTOMeta),
  meta: propertyMeta("meta", true, false, false, ReportMetaDTOMeta),
  typeCounts: propertyMeta(
    "typeCounts",
    true,
    false,
    false,
    ReportTypeCountDTOMeta,
  ),
  totalAmountPaidLineItems: propertyMeta(
    "totalAmountPaidLineItems",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  totalAmountBaseLineItems: propertyMeta(
    "totalAmountBaseLineItems",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  totalAmountSubtotalLineItems: propertyMeta(
    "totalAmountSubtotalLineItems",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  totalAmountTaxesLineItems: propertyMeta(
    "totalAmountTaxesLineItems",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  totalAmountTotalLineItems: propertyMeta(
    "totalAmountTotalLineItems",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  totalAmountDiscountLineItems: propertyMeta(
    "totalAmountDiscountLineItems",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  totalAmountPaymentsPaid: propertyMeta(
    "totalAmountPaymentsPaid",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  totalAmountStripePaymentsPaid: propertyMeta(
    "totalAmountStripePaymentsPaid",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  orderReports: propertyMeta(
    "orderReports",
    true,
    true,
    false,
    OrderReportDTOMeta,
  ),
  totalTotalAmountFromOrders: propertyMeta(
    "totalTotalAmountFromOrders",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  totalBaseAmountFromOrders: propertyMeta(
    "totalBaseAmountFromOrders",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  totalPaidAmountFromOrders: propertyMeta(
    "totalPaidAmountFromOrders",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
});

const metaI = OrderReportsDTOMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([ReportDTOMeta]);
  metaI.isDeleted.inheritedFrom = ReportDTOMeta.isDeleted;
  metaI.isNew.inheritedFrom = ReportDTOMeta.isNew;
  metaI.reportId.inheritedFrom = ReportDTOMeta.reportId;
  metaI.reportKey.inheritedFrom = ReportDTOMeta.reportKey;
  metaI.reportTitle.inheritedFrom = ReportDTOMeta.reportTitle;
  metaI.reportType.inheritedFrom = ReportDTOMeta.reportType;
  metaI.reportStatus.inheritedFrom = ReportDTOMeta.reportStatus;
  metaI.childReports.inheritedFrom = ReportDTOMeta.childReports;
  metaI.meta.inheritedFrom = ReportDTOMeta.meta;
  metaI.typeCounts.inheritedFrom = ReportDTOMeta.typeCounts;
  metaI.interfaces = metaI.interfaces.concat([OrderReportBaseMeta]);
  metaI.totalAmountPaidLineItems.inheritedFrom =
    OrderReportBaseMeta.totalAmountPaidLineItems;
  metaI.totalAmountBaseLineItems.inheritedFrom =
    OrderReportBaseMeta.totalAmountBaseLineItems;
  metaI.totalAmountSubtotalLineItems.inheritedFrom =
    OrderReportBaseMeta.totalAmountSubtotalLineItems;
  metaI.totalAmountTaxesLineItems.inheritedFrom =
    OrderReportBaseMeta.totalAmountTaxesLineItems;
  metaI.totalAmountTotalLineItems.inheritedFrom =
    OrderReportBaseMeta.totalAmountTotalLineItems;
  metaI.totalAmountDiscountLineItems.inheritedFrom =
    OrderReportBaseMeta.totalAmountDiscountLineItems;
  metaI.totalAmountPaymentsPaid.inheritedFrom =
    OrderReportBaseMeta.totalAmountPaymentsPaid;
  metaI.totalAmountStripePaymentsPaid.inheritedFrom =
    OrderReportBaseMeta.totalAmountStripePaymentsPaid;
});

export class OrderReportsDTOTracked
  extends OrderReportBaseTracked
  implements OrderReportsDTOTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  isDeleted__I?: boolean = undefined;
  isDeletedIsSet: boolean = false;
  set isDeleted(v: undefined | boolean) {
    if (v !== undefined) {
      this.isDeleted__I = v;
      this.isDeletedIsSet = true;
    } else {
      this.isDeleted__I = v || undefined;
      this.isDeletedIsSet = false;
    }
    this.changeTracker = true;
  }
  get isDeleted() {
    return this.isDeleted__I;
  }
  isNew__I?: boolean = undefined;
  isNewIsSet: boolean = false;
  set isNew(v: undefined | boolean) {
    if (v !== undefined) {
      this.isNew__I = v;
      this.isNewIsSet = true;
    } else {
      this.isNew__I = v || undefined;
      this.isNewIsSet = false;
    }
    this.changeTracker = true;
  }
  get isNew() {
    return this.isNew__I;
  }
  reportId__I?: number = undefined;

  get reportIdIsSet() {
    return this.reportId !== undefined;
  }
  set reportIdIsSet(v: boolean) {}
  set reportId(v: undefined | number) {
    if (v !== undefined) {
      this.reportId__I = v;
      this.reportIdIsSet = true;
    } else {
      this.reportId__I = v || undefined;
      this.reportIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get reportId() {
    return this.reportId__I;
  }
  reportKey__I?: string = undefined;
  reportKeyIsSet: boolean = false;
  set reportKey(v: undefined | string) {
    if (v !== undefined) {
      this.reportKey__I = v;
      this.reportKeyIsSet = true;
    } else {
      this.reportKey__I = v || undefined;
      this.reportKeyIsSet = true;
    }
    this.changeTracker = true;
  }
  get reportKey() {
    return this.reportKey__I;
  }
  reportTitle__I?: string = undefined;
  reportTitleIsSet: boolean = false;
  set reportTitle(v: undefined | string) {
    if (v !== undefined) {
      this.reportTitle__I = v;
      this.reportTitleIsSet = true;
    } else {
      this.reportTitle__I = v || undefined;
      this.reportTitleIsSet = false;
    }
    this.changeTracker = true;
  }
  get reportTitle() {
    return this.reportTitle__I;
  }
  reportType__I?: ReportType = undefined;
  reportTypeIsSet: boolean = false;
  set reportType(v: undefined | ReportType) {
    if (v !== undefined) {
      this.reportType__I = v;
      this.reportTypeIsSet = true;
    } else {
      this.reportType__I = v || undefined;
      this.reportTypeIsSet = false;
    }
    this.changeTracker = true;
  }
  get reportType() {
    return this.reportType__I;
  }
  reportStatus__I?: ReportStatus = undefined;
  reportStatusIsSet: boolean = false;
  set reportStatus(v: undefined | ReportStatus) {
    if (v !== undefined) {
      this.reportStatus__I = v;
      this.reportStatusIsSet = true;
    } else {
      this.reportStatus__I = v || undefined;
      this.reportStatusIsSet = false;
    }
    this.changeTracker = true;
  }
  get reportStatus() {
    return this.reportStatus__I;
  }
  childReports__I?: ReportDTOTracked[] = undefined;
  childReportsIsSet: boolean = false;
  set childReports(v: undefined | ReportDTOTracked[]) {
    if (v !== undefined) {
      this.childReports__I = v;
      this.childReportsIsSet = true;
    } else {
      this.childReports__I = v || undefined;
      this.childReportsIsSet = false;
    }
    this.changeTracker = true;
  }
  get childReports() {
    return this.childReports__I;
  }
  meta__I?: ReportMetaDTOTracked[] = undefined;
  metaIsSet: boolean = false;
  set meta(v: undefined | ReportMetaDTOTracked[]) {
    if (v !== undefined) {
      this.meta__I = v;
      this.metaIsSet = true;
    } else {
      this.meta__I = v || undefined;
      this.metaIsSet = false;
    }
    this.changeTracker = true;
  }
  get meta() {
    return this.meta__I;
  }
  typeCounts__I?: ReportTypeCountDTOTracked[] = undefined;
  typeCountsIsSet: boolean = false;
  set typeCounts(v: undefined | ReportTypeCountDTOTracked[]) {
    if (v !== undefined) {
      this.typeCounts__I = v;
      this.typeCountsIsSet = true;
    } else {
      this.typeCounts__I = v || undefined;
      this.typeCountsIsSet = false;
    }
    this.changeTracker = true;
  }
  get typeCounts() {
    return this.typeCounts__I;
  }
  totalAmountPaidLineItems__I?: number = undefined;
  totalAmountPaidLineItemsIsSet: boolean = false;
  set totalAmountPaidLineItems(v: undefined | number) {
    if (v !== undefined) {
      this.totalAmountPaidLineItems__I = v;
      this.totalAmountPaidLineItemsIsSet = true;
    } else {
      this.totalAmountPaidLineItems__I = v || undefined;
      this.totalAmountPaidLineItemsIsSet = false;
    }
    this.changeTracker = true;
  }
  get totalAmountPaidLineItems() {
    return this.totalAmountPaidLineItems__I;
  }
  totalAmountBaseLineItems__I?: number = undefined;
  totalAmountBaseLineItemsIsSet: boolean = false;
  set totalAmountBaseLineItems(v: undefined | number) {
    if (v !== undefined) {
      this.totalAmountBaseLineItems__I = v;
      this.totalAmountBaseLineItemsIsSet = true;
    } else {
      this.totalAmountBaseLineItems__I = v || undefined;
      this.totalAmountBaseLineItemsIsSet = false;
    }
    this.changeTracker = true;
  }
  get totalAmountBaseLineItems() {
    return this.totalAmountBaseLineItems__I;
  }
  totalAmountSubtotalLineItems__I?: number = undefined;
  totalAmountSubtotalLineItemsIsSet: boolean = false;
  set totalAmountSubtotalLineItems(v: undefined | number) {
    if (v !== undefined) {
      this.totalAmountSubtotalLineItems__I = v;
      this.totalAmountSubtotalLineItemsIsSet = true;
    } else {
      this.totalAmountSubtotalLineItems__I = v || undefined;
      this.totalAmountSubtotalLineItemsIsSet = false;
    }
    this.changeTracker = true;
  }
  get totalAmountSubtotalLineItems() {
    return this.totalAmountSubtotalLineItems__I;
  }
  totalAmountTaxesLineItems__I?: number = undefined;
  totalAmountTaxesLineItemsIsSet: boolean = false;
  set totalAmountTaxesLineItems(v: undefined | number) {
    if (v !== undefined) {
      this.totalAmountTaxesLineItems__I = v;
      this.totalAmountTaxesLineItemsIsSet = true;
    } else {
      this.totalAmountTaxesLineItems__I = v || undefined;
      this.totalAmountTaxesLineItemsIsSet = false;
    }
    this.changeTracker = true;
  }
  get totalAmountTaxesLineItems() {
    return this.totalAmountTaxesLineItems__I;
  }
  totalAmountTotalLineItems__I?: number = undefined;
  totalAmountTotalLineItemsIsSet: boolean = false;
  set totalAmountTotalLineItems(v: undefined | number) {
    if (v !== undefined) {
      this.totalAmountTotalLineItems__I = v;
      this.totalAmountTotalLineItemsIsSet = true;
    } else {
      this.totalAmountTotalLineItems__I = v || undefined;
      this.totalAmountTotalLineItemsIsSet = false;
    }
    this.changeTracker = true;
  }
  get totalAmountTotalLineItems() {
    return this.totalAmountTotalLineItems__I;
  }
  totalAmountDiscountLineItems__I?: number = undefined;
  totalAmountDiscountLineItemsIsSet: boolean = false;
  set totalAmountDiscountLineItems(v: undefined | number) {
    if (v !== undefined) {
      this.totalAmountDiscountLineItems__I = v;
      this.totalAmountDiscountLineItemsIsSet = true;
    } else {
      this.totalAmountDiscountLineItems__I = v || undefined;
      this.totalAmountDiscountLineItemsIsSet = false;
    }
    this.changeTracker = true;
  }
  get totalAmountDiscountLineItems() {
    return this.totalAmountDiscountLineItems__I;
  }
  totalAmountPaymentsPaid__I?: number = undefined;
  totalAmountPaymentsPaidIsSet: boolean = false;
  set totalAmountPaymentsPaid(v: undefined | number) {
    if (v !== undefined) {
      this.totalAmountPaymentsPaid__I = v;
      this.totalAmountPaymentsPaidIsSet = true;
    } else {
      this.totalAmountPaymentsPaid__I = v || undefined;
      this.totalAmountPaymentsPaidIsSet = false;
    }
    this.changeTracker = true;
  }
  get totalAmountPaymentsPaid() {
    return this.totalAmountPaymentsPaid__I;
  }
  totalAmountStripePaymentsPaid__I?: number = undefined;
  totalAmountStripePaymentsPaidIsSet: boolean = false;
  set totalAmountStripePaymentsPaid(v: undefined | number) {
    if (v !== undefined) {
      this.totalAmountStripePaymentsPaid__I = v;
      this.totalAmountStripePaymentsPaidIsSet = true;
    } else {
      this.totalAmountStripePaymentsPaid__I = v || undefined;
      this.totalAmountStripePaymentsPaidIsSet = false;
    }
    this.changeTracker = true;
  }
  get totalAmountStripePaymentsPaid() {
    return this.totalAmountStripePaymentsPaid__I;
  }
  orderReports__I?: OrderReportDTOTracked[] = undefined;
  orderReportsIsSet: boolean = false;
  set orderReports(v: undefined | OrderReportDTOTracked[]) {
    if (v !== undefined) {
      this.orderReports__I = v;
      this.orderReportsIsSet = true;
    } else {
      this.orderReports__I = v || undefined;
      this.orderReportsIsSet = true;
    }
    this.changeTracker = true;
  }
  get orderReports() {
    return this.orderReports__I;
  }
  totalTotalAmountFromOrders__I?: number = undefined;
  totalTotalAmountFromOrdersIsSet: boolean = false;
  set totalTotalAmountFromOrders(v: undefined | number) {
    if (v !== undefined) {
      this.totalTotalAmountFromOrders__I = v;
      this.totalTotalAmountFromOrdersIsSet = true;
    } else {
      this.totalTotalAmountFromOrders__I = v || undefined;
      this.totalTotalAmountFromOrdersIsSet = false;
    }
    this.changeTracker = true;
  }
  get totalTotalAmountFromOrders() {
    return this.totalTotalAmountFromOrders__I;
  }
  totalBaseAmountFromOrders__I?: number = undefined;
  totalBaseAmountFromOrdersIsSet: boolean = false;
  set totalBaseAmountFromOrders(v: undefined | number) {
    if (v !== undefined) {
      this.totalBaseAmountFromOrders__I = v;
      this.totalBaseAmountFromOrdersIsSet = true;
    } else {
      this.totalBaseAmountFromOrders__I = v || undefined;
      this.totalBaseAmountFromOrdersIsSet = false;
    }
    this.changeTracker = true;
  }
  get totalBaseAmountFromOrders() {
    return this.totalBaseAmountFromOrders__I;
  }
  totalPaidAmountFromOrders__I?: number = undefined;
  totalPaidAmountFromOrdersIsSet: boolean = false;
  set totalPaidAmountFromOrders(v: undefined | number) {
    if (v !== undefined) {
      this.totalPaidAmountFromOrders__I = v;
      this.totalPaidAmountFromOrdersIsSet = true;
    } else {
      this.totalPaidAmountFromOrders__I = v || undefined;
      this.totalPaidAmountFromOrdersIsSet = false;
    }
    this.changeTracker = true;
  }
  get totalPaidAmountFromOrders() {
    return this.totalPaidAmountFromOrders__I;
  }
  constructor(config?: OrderReportsDTOOptional, options?: AssignOptions) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.reportIdIsSet == true && other?.reportIdIsSet == true)
      return this.reportId == other.reportId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.reportId) {
      this.reportIdIsSet = true;
    }

    this.childReports?.forEach((a) => a.setIds());

    this.meta?.forEach((a) => a.setIds());

    this.typeCounts?.forEach((a) => a.setIds());

    this.orderReports?.forEach((a) => a.setIds());
  }
  assignFrom(
    config: OrderReportsDTOOptional,
    options?: AssignOptions,
  ): OrderReportsDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.isDeleted && this.isDeletedApplyFilter(optionsRequired.filter)) {
      this.isDeleted = config.isDeleted;
      if (optionsRequired.unassign) this.isDeletedIsSet = false;
      else this.isDeletedIsSet = true;
    }
    if (config.isNew && this.isNewApplyFilter(optionsRequired.filter)) {
      this.isNew = config.isNew;
      if (optionsRequired.unassign) this.isNewIsSet = false;
      else this.isNewIsSet = true;
    }
    if (config.reportId && this.reportIdApplyFilter(optionsRequired.filter)) {
      this.reportId = config.reportId;
      if (optionsRequired.unassign) this.reportIdIsSet = false;
      else this.reportIdIsSet = true;
    }
    if (config.reportKey && this.reportKeyApplyFilter(optionsRequired.filter)) {
      this.reportKey = config.reportKey;
      if (optionsRequired.unassign) this.reportKeyIsSet = false;
      else this.reportKeyIsSet = true;
    }
    if (
      config.reportTitle &&
      this.reportTitleApplyFilter(optionsRequired.filter)
    ) {
      this.reportTitle = config.reportTitle;
      if (optionsRequired.unassign) this.reportTitleIsSet = false;
      else this.reportTitleIsSet = true;
    }
    if (
      config.reportType &&
      this.reportTypeApplyFilter(optionsRequired.filter)
    ) {
      this.reportType = config.reportType;
      if (optionsRequired.unassign) this.reportTypeIsSet = false;
      else this.reportTypeIsSet = true;
    }
    if (
      config.reportStatus &&
      this.reportStatusApplyFilter(optionsRequired.filter)
    ) {
      this.reportStatus = config.reportStatus;
      if (optionsRequired.unassign) this.reportStatusIsSet = false;
      else this.reportStatusIsSet = true;
    }
    if (
      config.childReports &&
      this.childReportsApplyFilter(optionsRequired.filter)
    ) {
      this.childReports = config.childReports?.map(
        (a) => new ReportDTOTracked(a, options),
      );
      if (optionsRequired.unassign) this.childReportsIsSet = false;
      else this.childReportsIsSet = true;
    }
    if (config.meta && this.metaApplyFilter(optionsRequired.filter)) {
      this.meta = config.meta?.map((a) => new ReportMetaDTOTracked(a, options));
      if (optionsRequired.unassign) this.metaIsSet = false;
      else this.metaIsSet = true;
    }
    if (
      config.typeCounts &&
      this.typeCountsApplyFilter(optionsRequired.filter)
    ) {
      this.typeCounts = config.typeCounts?.map(
        (a) => new ReportTypeCountDTOTracked(a, options),
      );
      if (optionsRequired.unassign) this.typeCountsIsSet = false;
      else this.typeCountsIsSet = true;
    }
    if (
      config.totalAmountPaidLineItems &&
      this.totalAmountPaidLineItemsApplyFilter(optionsRequired.filter)
    ) {
      this.totalAmountPaidLineItems = config.totalAmountPaidLineItems;
      if (optionsRequired.unassign) this.totalAmountPaidLineItemsIsSet = false;
      else this.totalAmountPaidLineItemsIsSet = true;
    }
    if (
      config.totalAmountBaseLineItems &&
      this.totalAmountBaseLineItemsApplyFilter(optionsRequired.filter)
    ) {
      this.totalAmountBaseLineItems = config.totalAmountBaseLineItems;
      if (optionsRequired.unassign) this.totalAmountBaseLineItemsIsSet = false;
      else this.totalAmountBaseLineItemsIsSet = true;
    }
    if (
      config.totalAmountSubtotalLineItems &&
      this.totalAmountSubtotalLineItemsApplyFilter(optionsRequired.filter)
    ) {
      this.totalAmountSubtotalLineItems = config.totalAmountSubtotalLineItems;
      if (optionsRequired.unassign)
        this.totalAmountSubtotalLineItemsIsSet = false;
      else this.totalAmountSubtotalLineItemsIsSet = true;
    }
    if (
      config.totalAmountTaxesLineItems &&
      this.totalAmountTaxesLineItemsApplyFilter(optionsRequired.filter)
    ) {
      this.totalAmountTaxesLineItems = config.totalAmountTaxesLineItems;
      if (optionsRequired.unassign) this.totalAmountTaxesLineItemsIsSet = false;
      else this.totalAmountTaxesLineItemsIsSet = true;
    }
    if (
      config.totalAmountTotalLineItems &&
      this.totalAmountTotalLineItemsApplyFilter(optionsRequired.filter)
    ) {
      this.totalAmountTotalLineItems = config.totalAmountTotalLineItems;
      if (optionsRequired.unassign) this.totalAmountTotalLineItemsIsSet = false;
      else this.totalAmountTotalLineItemsIsSet = true;
    }
    if (
      config.totalAmountDiscountLineItems &&
      this.totalAmountDiscountLineItemsApplyFilter(optionsRequired.filter)
    ) {
      this.totalAmountDiscountLineItems = config.totalAmountDiscountLineItems;
      if (optionsRequired.unassign)
        this.totalAmountDiscountLineItemsIsSet = false;
      else this.totalAmountDiscountLineItemsIsSet = true;
    }
    if (
      config.totalAmountPaymentsPaid &&
      this.totalAmountPaymentsPaidApplyFilter(optionsRequired.filter)
    ) {
      this.totalAmountPaymentsPaid = config.totalAmountPaymentsPaid;
      if (optionsRequired.unassign) this.totalAmountPaymentsPaidIsSet = false;
      else this.totalAmountPaymentsPaidIsSet = true;
    }
    if (
      config.totalAmountStripePaymentsPaid &&
      this.totalAmountStripePaymentsPaidApplyFilter(optionsRequired.filter)
    ) {
      this.totalAmountStripePaymentsPaid = config.totalAmountStripePaymentsPaid;
      if (optionsRequired.unassign)
        this.totalAmountStripePaymentsPaidIsSet = false;
      else this.totalAmountStripePaymentsPaidIsSet = true;
    }
    if (
      config.orderReports &&
      this.orderReportsApplyFilter(optionsRequired.filter)
    ) {
      this.orderReports = config.orderReports?.map(
        (a) => new OrderReportDTOTracked(a, options),
      );
      if (optionsRequired.unassign) this.orderReportsIsSet = false;
      else this.orderReportsIsSet = true;
    }
    if (
      config.totalTotalAmountFromOrders &&
      this.totalTotalAmountFromOrdersApplyFilter(optionsRequired.filter)
    ) {
      this.totalTotalAmountFromOrders = config.totalTotalAmountFromOrders;
      if (optionsRequired.unassign)
        this.totalTotalAmountFromOrdersIsSet = false;
      else this.totalTotalAmountFromOrdersIsSet = true;
    }
    if (
      config.totalBaseAmountFromOrders &&
      this.totalBaseAmountFromOrdersApplyFilter(optionsRequired.filter)
    ) {
      this.totalBaseAmountFromOrders = config.totalBaseAmountFromOrders;
      if (optionsRequired.unassign) this.totalBaseAmountFromOrdersIsSet = false;
      else this.totalBaseAmountFromOrdersIsSet = true;
    }
    if (
      config.totalPaidAmountFromOrders &&
      this.totalPaidAmountFromOrdersApplyFilter(optionsRequired.filter)
    ) {
      this.totalPaidAmountFromOrders = config.totalPaidAmountFromOrders;
      if (optionsRequired.unassign) this.totalPaidAmountFromOrdersIsSet = false;
      else this.totalPaidAmountFromOrdersIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): OrderReportsDTOTrackedI {
    const cloned = {} as OrderReportsDTOTrackedI;
    if (
      this.isDeletedIsSetDeep() &&
      this.isDeletedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isDeletedIsSet = true;
      cloned.isDeleted = this.isDeleted;
    } else {
      //cloned.isDeletedIsSet = false
    }
    if (
      this.isNewIsSetDeep() &&
      this.isNewApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isNewIsSet = true;
      cloned.isNew = this.isNew;
    } else {
      //cloned.isNewIsSet = false
    }
    if (
      this.reportIdIsSetDeep() &&
      this.reportIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.reportIdIsSet = true;
      cloned.reportId = this.reportId;
    } else {
      //cloned.reportIdIsSet = false
    }
    if (
      this.reportKeyIsSetDeep() &&
      this.reportKeyApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.reportKeyIsSet = true;
      cloned.reportKey = this.reportKey;
    } else {
      //cloned.reportKeyIsSet = false
    }
    if (
      this.reportTitleIsSetDeep() &&
      this.reportTitleApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.reportTitleIsSet = true;
      cloned.reportTitle = this.reportTitle;
    } else {
      //cloned.reportTitleIsSet = false
    }
    if (
      this.reportTypeIsSetDeep() &&
      this.reportTypeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.reportTypeIsSet = true;
      cloned.reportType = this.reportType;
    } else {
      //cloned.reportTypeIsSet = false
    }
    if (
      this.reportStatusIsSetDeep() &&
      this.reportStatusApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.reportStatusIsSet = true;
      cloned.reportStatus = this.reportStatus;
    } else {
      //cloned.reportStatusIsSet = false
    }
    if (
      this.childReportsIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.childReportsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.childReportsIsSet = true;
      cloned.childReports = this.childReports
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.childReportsIsSet = false
    }
    if (
      this.metaIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.metaApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.metaIsSet = true;
      cloned.meta = this.meta
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.metaIsSet = false
    }
    if (
      this.typeCountsIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.typeCountsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.typeCountsIsSet = true;
      cloned.typeCounts = this.typeCounts
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.typeCountsIsSet = false
    }
    if (
      this.totalAmountPaidLineItemsIsSetDeep() &&
      this.totalAmountPaidLineItemsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.totalAmountPaidLineItemsIsSet = true;
      cloned.totalAmountPaidLineItems = this.totalAmountPaidLineItems;
    } else {
      //cloned.totalAmountPaidLineItemsIsSet = false
    }
    if (
      this.totalAmountBaseLineItemsIsSetDeep() &&
      this.totalAmountBaseLineItemsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.totalAmountBaseLineItemsIsSet = true;
      cloned.totalAmountBaseLineItems = this.totalAmountBaseLineItems;
    } else {
      //cloned.totalAmountBaseLineItemsIsSet = false
    }
    if (
      this.totalAmountSubtotalLineItemsIsSetDeep() &&
      this.totalAmountSubtotalLineItemsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.totalAmountSubtotalLineItemsIsSet = true;
      cloned.totalAmountSubtotalLineItems = this.totalAmountSubtotalLineItems;
    } else {
      //cloned.totalAmountSubtotalLineItemsIsSet = false
    }
    if (
      this.totalAmountTaxesLineItemsIsSetDeep() &&
      this.totalAmountTaxesLineItemsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.totalAmountTaxesLineItemsIsSet = true;
      cloned.totalAmountTaxesLineItems = this.totalAmountTaxesLineItems;
    } else {
      //cloned.totalAmountTaxesLineItemsIsSet = false
    }
    if (
      this.totalAmountTotalLineItemsIsSetDeep() &&
      this.totalAmountTotalLineItemsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.totalAmountTotalLineItemsIsSet = true;
      cloned.totalAmountTotalLineItems = this.totalAmountTotalLineItems;
    } else {
      //cloned.totalAmountTotalLineItemsIsSet = false
    }
    if (
      this.totalAmountDiscountLineItemsIsSetDeep() &&
      this.totalAmountDiscountLineItemsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.totalAmountDiscountLineItemsIsSet = true;
      cloned.totalAmountDiscountLineItems = this.totalAmountDiscountLineItems;
    } else {
      //cloned.totalAmountDiscountLineItemsIsSet = false
    }
    if (
      this.totalAmountPaymentsPaidIsSetDeep() &&
      this.totalAmountPaymentsPaidApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.totalAmountPaymentsPaidIsSet = true;
      cloned.totalAmountPaymentsPaid = this.totalAmountPaymentsPaid;
    } else {
      //cloned.totalAmountPaymentsPaidIsSet = false
    }
    if (
      this.totalAmountStripePaymentsPaidIsSetDeep() &&
      this.totalAmountStripePaymentsPaidApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.totalAmountStripePaymentsPaidIsSet = true;
      cloned.totalAmountStripePaymentsPaid = this.totalAmountStripePaymentsPaid;
    } else {
      //cloned.totalAmountStripePaymentsPaidIsSet = false
    }
    if (
      this.orderReportsIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.orderReportsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.orderReportsIsSet = true;
      cloned.orderReports = this.orderReports
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.orderReportsIsSet = false
    }
    if (
      this.totalTotalAmountFromOrdersIsSetDeep() &&
      this.totalTotalAmountFromOrdersApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.totalTotalAmountFromOrdersIsSet = true;
      cloned.totalTotalAmountFromOrders = this.totalTotalAmountFromOrders;
    } else {
      //cloned.totalTotalAmountFromOrdersIsSet = false
    }
    if (
      this.totalBaseAmountFromOrdersIsSetDeep() &&
      this.totalBaseAmountFromOrdersApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.totalBaseAmountFromOrdersIsSet = true;
      cloned.totalBaseAmountFromOrders = this.totalBaseAmountFromOrders;
    } else {
      //cloned.totalBaseAmountFromOrdersIsSet = false
    }
    if (
      this.totalPaidAmountFromOrdersIsSetDeep() &&
      this.totalPaidAmountFromOrdersApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.totalPaidAmountFromOrdersIsSet = true;
      cloned.totalPaidAmountFromOrders = this.totalPaidAmountFromOrders;
    } else {
      //cloned.totalPaidAmountFromOrdersIsSet = false
    }
    if (!isDeleted(this) && !this.reportIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): OrderReportsDTOTrackedI {
    if (!this.isDeletedApplyFilter(filter)) this.isDeletedIsSet = false;

    if (!this.isNewApplyFilter(filter)) this.isNewIsSet = false;

    if (!this.reportIdApplyFilter(filter)) this.reportIdIsSet = false;

    if (!this.reportKeyApplyFilter(filter)) this.reportKeyIsSet = false;

    if (!this.reportTitleApplyFilter(filter)) this.reportTitleIsSet = false;

    if (!this.reportTypeApplyFilter(filter)) this.reportTypeIsSet = false;

    if (!this.reportStatusApplyFilter(filter)) this.reportStatusIsSet = false;

    if (!this.childReportsApplyFilter(filter)) this.childReportsIsSet = false;

    this.childReports?.forEach((a) => a.unassignAll(filter));
    if (!this.metaApplyFilter(filter)) this.metaIsSet = false;

    this.meta?.forEach((a) => a.unassignAll(filter));
    if (!this.typeCountsApplyFilter(filter)) this.typeCountsIsSet = false;

    this.typeCounts?.forEach((a) => a.unassignAll(filter));
    if (!this.totalAmountPaidLineItemsApplyFilter(filter))
      this.totalAmountPaidLineItemsIsSet = false;

    if (!this.totalAmountBaseLineItemsApplyFilter(filter))
      this.totalAmountBaseLineItemsIsSet = false;

    if (!this.totalAmountSubtotalLineItemsApplyFilter(filter))
      this.totalAmountSubtotalLineItemsIsSet = false;

    if (!this.totalAmountTaxesLineItemsApplyFilter(filter))
      this.totalAmountTaxesLineItemsIsSet = false;

    if (!this.totalAmountTotalLineItemsApplyFilter(filter))
      this.totalAmountTotalLineItemsIsSet = false;

    if (!this.totalAmountDiscountLineItemsApplyFilter(filter))
      this.totalAmountDiscountLineItemsIsSet = false;

    if (!this.totalAmountPaymentsPaidApplyFilter(filter))
      this.totalAmountPaymentsPaidIsSet = false;

    if (!this.totalAmountStripePaymentsPaidApplyFilter(filter))
      this.totalAmountStripePaymentsPaidIsSet = false;

    if (!this.orderReportsApplyFilter(filter)) this.orderReportsIsSet = false;

    this.orderReports?.forEach((a) => a.unassignAll(filter));
    if (!this.totalTotalAmountFromOrdersApplyFilter(filter))
      this.totalTotalAmountFromOrdersIsSet = false;

    if (!this.totalBaseAmountFromOrdersApplyFilter(filter))
      this.totalBaseAmountFromOrdersIsSet = false;

    if (!this.totalPaidAmountFromOrdersApplyFilter(filter))
      this.totalPaidAmountFromOrdersIsSet = false;

    return this;
  }
  isDeletedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderReportsDTOMeta.isDeleted,
      OrderReportsDTOMeta,
      this.isDeleted,
      this,
    );
  }
  isDeletedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isDeletedIsSet && this.isDeletedApplyFilter(filter)) return true;

    return false;
  }
  isNewApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderReportsDTOMeta.isNew,
      OrderReportsDTOMeta,
      this.isNew,
      this,
    );
  }
  isNewIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isNewIsSet && this.isNewApplyFilter(filter)) return true;

    return false;
  }
  reportIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderReportsDTOMeta.reportId,
      OrderReportsDTOMeta,
      this.reportId,
      this,
    );
  }
  reportIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.reportIdIsSet && this.reportIdApplyFilter(filter)) return true;

    return false;
  }
  reportKeyApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderReportsDTOMeta.reportKey,
      OrderReportsDTOMeta,
      this.reportKey,
      this,
    );
  }
  reportKeyIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.reportKeyIsSet && this.reportKeyApplyFilter(filter)) return true;

    return false;
  }
  reportTitleApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderReportsDTOMeta.reportTitle,
      OrderReportsDTOMeta,
      this.reportTitle,
      this,
    );
  }
  reportTitleIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.reportTitleIsSet && this.reportTitleApplyFilter(filter))
      return true;

    return false;
  }
  reportTypeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderReportsDTOMeta.reportType,
      OrderReportsDTOMeta,
      this.reportType,
      this,
    );
  }
  reportTypeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.reportTypeIsSet && this.reportTypeApplyFilter(filter)) return true;

    return false;
  }
  reportStatusApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderReportsDTOMeta.reportStatus,
      OrderReportsDTOMeta,
      this.reportStatus,
      this,
    );
  }
  reportStatusIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.reportStatusIsSet && this.reportStatusApplyFilter(filter))
      return true;

    return false;
  }
  childReportsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderReportsDTOMeta.childReports,
      OrderReportsDTOMeta,
      this.childReports,
      this,
    );
  }
  childReportsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.childReportsIsSet && this.childReportsApplyFilter(filter))
      return true;

    return this.childReports?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  metaApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderReportsDTOMeta.meta,
      OrderReportsDTOMeta,
      this.meta,
      this,
    );
  }
  metaIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.metaIsSet && this.metaApplyFilter(filter)) return true;

    return this.meta?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  typeCountsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderReportsDTOMeta.typeCounts,
      OrderReportsDTOMeta,
      this.typeCounts,
      this,
    );
  }
  typeCountsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.typeCountsIsSet && this.typeCountsApplyFilter(filter)) return true;

    return this.typeCounts?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  totalAmountPaidLineItemsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderReportsDTOMeta.totalAmountPaidLineItems,
      OrderReportsDTOMeta,
      this.totalAmountPaidLineItems,
      this,
    );
  }
  totalAmountPaidLineItemsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.totalAmountPaidLineItemsIsSet &&
      this.totalAmountPaidLineItemsApplyFilter(filter)
    )
      return true;

    return false;
  }
  totalAmountBaseLineItemsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderReportsDTOMeta.totalAmountBaseLineItems,
      OrderReportsDTOMeta,
      this.totalAmountBaseLineItems,
      this,
    );
  }
  totalAmountBaseLineItemsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.totalAmountBaseLineItemsIsSet &&
      this.totalAmountBaseLineItemsApplyFilter(filter)
    )
      return true;

    return false;
  }
  totalAmountSubtotalLineItemsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderReportsDTOMeta.totalAmountSubtotalLineItems,
      OrderReportsDTOMeta,
      this.totalAmountSubtotalLineItems,
      this,
    );
  }
  totalAmountSubtotalLineItemsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.totalAmountSubtotalLineItemsIsSet &&
      this.totalAmountSubtotalLineItemsApplyFilter(filter)
    )
      return true;

    return false;
  }
  totalAmountTaxesLineItemsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderReportsDTOMeta.totalAmountTaxesLineItems,
      OrderReportsDTOMeta,
      this.totalAmountTaxesLineItems,
      this,
    );
  }
  totalAmountTaxesLineItemsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.totalAmountTaxesLineItemsIsSet &&
      this.totalAmountTaxesLineItemsApplyFilter(filter)
    )
      return true;

    return false;
  }
  totalAmountTotalLineItemsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderReportsDTOMeta.totalAmountTotalLineItems,
      OrderReportsDTOMeta,
      this.totalAmountTotalLineItems,
      this,
    );
  }
  totalAmountTotalLineItemsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.totalAmountTotalLineItemsIsSet &&
      this.totalAmountTotalLineItemsApplyFilter(filter)
    )
      return true;

    return false;
  }
  totalAmountDiscountLineItemsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderReportsDTOMeta.totalAmountDiscountLineItems,
      OrderReportsDTOMeta,
      this.totalAmountDiscountLineItems,
      this,
    );
  }
  totalAmountDiscountLineItemsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.totalAmountDiscountLineItemsIsSet &&
      this.totalAmountDiscountLineItemsApplyFilter(filter)
    )
      return true;

    return false;
  }
  totalAmountPaymentsPaidApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderReportsDTOMeta.totalAmountPaymentsPaid,
      OrderReportsDTOMeta,
      this.totalAmountPaymentsPaid,
      this,
    );
  }
  totalAmountPaymentsPaidIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.totalAmountPaymentsPaidIsSet &&
      this.totalAmountPaymentsPaidApplyFilter(filter)
    )
      return true;

    return false;
  }
  totalAmountStripePaymentsPaidApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderReportsDTOMeta.totalAmountStripePaymentsPaid,
      OrderReportsDTOMeta,
      this.totalAmountStripePaymentsPaid,
      this,
    );
  }
  totalAmountStripePaymentsPaidIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.totalAmountStripePaymentsPaidIsSet &&
      this.totalAmountStripePaymentsPaidApplyFilter(filter)
    )
      return true;

    return false;
  }
  orderReportsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderReportsDTOMeta.orderReports,
      OrderReportsDTOMeta,
      this.orderReports,
      this,
    );
  }
  orderReportsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.orderReportsIsSet && this.orderReportsApplyFilter(filter))
      return true;

    return this.orderReports?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  totalTotalAmountFromOrdersApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderReportsDTOMeta.totalTotalAmountFromOrders,
      OrderReportsDTOMeta,
      this.totalTotalAmountFromOrders,
      this,
    );
  }
  totalTotalAmountFromOrdersIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.totalTotalAmountFromOrdersIsSet &&
      this.totalTotalAmountFromOrdersApplyFilter(filter)
    )
      return true;

    return false;
  }
  totalBaseAmountFromOrdersApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderReportsDTOMeta.totalBaseAmountFromOrders,
      OrderReportsDTOMeta,
      this.totalBaseAmountFromOrders,
      this,
    );
  }
  totalBaseAmountFromOrdersIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.totalBaseAmountFromOrdersIsSet &&
      this.totalBaseAmountFromOrdersApplyFilter(filter)
    )
      return true;

    return false;
  }
  totalPaidAmountFromOrdersApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderReportsDTOMeta.totalPaidAmountFromOrders,
      OrderReportsDTOMeta,
      this.totalPaidAmountFromOrders,
      this,
    );
  }
  totalPaidAmountFromOrdersIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.totalPaidAmountFromOrdersIsSet &&
      this.totalPaidAmountFromOrdersApplyFilter(filter)
    )
      return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.isDeletedIsSetDeep(filter)) return true;
    if (this.isNewIsSetDeep(filter)) return true;
    if (this.reportIdIsSetDeep(filter)) return true;
    if (this.reportKeyIsSetDeep(filter)) return true;
    if (this.reportTitleIsSetDeep(filter)) return true;
    if (this.reportTypeIsSetDeep(filter)) return true;
    if (this.reportStatusIsSetDeep(filter)) return true;
    if (this.childReportsIsSetDeep(filter)) return true;
    if (this.metaIsSetDeep(filter)) return true;
    if (this.typeCountsIsSetDeep(filter)) return true;
    if (this.totalAmountPaidLineItemsIsSetDeep(filter)) return true;
    if (this.totalAmountBaseLineItemsIsSetDeep(filter)) return true;
    if (this.totalAmountSubtotalLineItemsIsSetDeep(filter)) return true;
    if (this.totalAmountTaxesLineItemsIsSetDeep(filter)) return true;
    if (this.totalAmountTotalLineItemsIsSetDeep(filter)) return true;
    if (this.totalAmountDiscountLineItemsIsSetDeep(filter)) return true;
    if (this.totalAmountPaymentsPaidIsSetDeep(filter)) return true;
    if (this.totalAmountStripePaymentsPaidIsSetDeep(filter)) return true;
    if (this.orderReportsIsSetDeep(filter)) return true;
    if (this.totalTotalAmountFromOrdersIsSetDeep(filter)) return true;
    if (this.totalBaseAmountFromOrdersIsSetDeep(filter)) return true;
    if (this.totalPaidAmountFromOrdersIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
